const Loader = ({ fixed = true, show, title, subTitle }) => {
  return (
    <>
      {show && (
        <div className={`loader ${fixed ? "fixed" : ""}`}>
          <div className="spinner">
            <div className="spinner-border">
              <span className="sr-only" />
            </div>
            {!!title && <span>{title}</span>}
            {!!subTitle && <span>{subTitle}</span>}
          </div>
        </div>
      )}
    </>
  );
};

export default Loader;
